import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Route, Switch, Redirect } from "react-router-dom";
import { createBrowserHistory } from "history";



import Home from "./../../Pages/Home";
import Page1 from "./../../Pages/Page1";
import Page2 from "./../../Pages/Page2";
import Page3 from "./../../Pages/Page3";
import News from "./../../Pages/News";
import NewDetail from "./../../Pages/NewDetail";
import ContactUs from "./../../Pages/ContactUs";
import Recruitment from "./../../Pages/Recruitment";
import Company from "./../../Pages/Company";



import "./Wrapper.css";
import ScrollToTop from "react-scroll-up";

import Banner from "./../Banner";
import Navbar from "./../Navbar";
import Footer from "./../Footer";

import { fetchDataAction } from "./../../actions/fetchDataActions.js";

export default function Wrapper(props) {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.data.data);
  const loading = useSelector((state) => state.data.loading);
  

  useEffect(() => {
    const history = createBrowserHistory()
    const urlParams = new URLSearchParams(window.location.search);
    dispatch(fetchDataAction(history.location,urlParams));
  }, []);
  
  var display = null;
  if (data)
    
    display = (
      <div className="container z-depth-2 animated fadeIn">
        <Banner data={data.contact_info} logo={data.logo} custom_design={data.custom_design}/>
        <Navbar custom_design={data.custom_design}  />
        <Switch>
          <Route exact path="/"   render={(props)=> <Home  data={data}   custom_design={data.custom_design} /> }  />
          <Route exact path="/page1" render={(props)=> <Page1  custom_design={data.custom_design} data={data} /> } />
          <Route exact path="/page2" render={(props)=> <Page2  data={data} /> } />
          <Route exact path="/page3" render={(props)=> <Page3   custom_design={data.custom_design} data={data} /> } />
          <Route exact path="/news" render={(props)=>  <News  data={data} /> } />
          <Route exact path="/new" render={(props)=>  <NewDetail  data={data} /> } />
          <Route exact path="/recruitment" render={(props)=>  <Recruitment  data={data} /> } />
          <Route exact path="/company" render={(props)=>  <Company  data={data} /> } />
          <Route exact path="/contactus"  render={(props)=>  <ContactUs  data={data}  custom_design={data.custom_design} /> }   />
        </Switch>
        <ScrollToTop showUnder={50}>
          <span className="scroll_button">
            <i className="material-icons">arrow_upward</i>
          </span>
        </ScrollToTop>
        <Footer data={data.contact_info}  custom_design={data.custom_design}/>
      </div>
    );


  return <>{display}</>;
}
